/*!
 * vimeo.ga.js | v0.6
 * Based on modifications by LukasBeaton (https://github.com/LukasBeaton/vimeo.ga.js)
 * Copyright (c) 2015 Sander Heilbron (http://www.sanderheilbron.nl)
 * MIT licensed
 */
var $ = require('jquery');
var Analytics = require('@plaudit/analytics').Analytics;
var analytics = Analytics.getInstance();

var vimeoGAJS = (window.vimeoGAJS) ? window.vimeoGAJS : {};

vimeoGAJS = {
	iframes: [],
	eventMarker: {},

	// add: function (iframe) {

	//     var iframeId = $(iframe).attr('id');

	//     vimeoGAJS.getIFrameEventMarkerData(iframeId) = {
	//       'progress25' : false,
	//       'progress50' : false,
	//       'progress75' : false,
	//       'videoPlayed' : false,
	//       'videoPaused' : false,
	//       'videoResumed' : false,
	//       'videoSeeking' : false,
	//       'videoCompleted' : false,
	//       'timePercentComplete' : 0
	//     };
	// },
	getIFrameEventMarkerData: function(iframeId) {
		if (vimeoGAJS.eventMarker[iframeId] === undefined) {
			vimeoGAJS.eventMarker[iframeId] = {
				'progress25': false,
				'progress50': false,
				'progress75': false,
				'videoPlayed': false,
				'videoPaused': false,
				'videoResumed': false,
				'videoSeeking': false,
				'videoCompleted': false,
				'timePercentComplete': 0
			};
		}
		return vimeoGAJS.eventMarker[iframeId];
	},
	init: function() {
		var self = this;

		// Listen for messages from the player
		if (window.addEventListener) {
			window.addEventListener('message', vimeoGAJS.onMessageReceived, false);
		} else {
			window.attachEvent('onmessage', vimeoGAJS.onMessageReceived, false);
		}
	},

	// Handle messages received from the player
	onMessageReceived: function(e) {
		
		if (e.origin.replace('https:', 'http:') !== "http://player.vimeo.com") {
			if (e.origin.indexOf('youtube.com') !== -1) {
				// TOOD: Remove me
				var messageData = JSON.parse(e.data);
			}
			return;
		}

		var data = JSON.parse(e.data),
			iframeEl = $("#" + data.player_id),
			iframeId = iframeEl.attr('id');

		if (iframeEl.length === 0 || !vimeoGAJS.isVimeoIFrame(iframeEl.get(0))) {
			return;
		}

		switch (data.event) {
			case 'ready':
				vimeoGAJS.onReady(iframeEl.get(0));
				break;

			case 'playProgress':
				vimeoGAJS.onPlayProgress(data.data, iframeEl);
				break;

			case 'seek':
				if (iframeEl.data('seek') && !vimeoGAJS.getIFrameEventMarkerData(iframeId).videoSeeking) {
					vimeoGAJS.sendEvent(iframeEl, 'Skipped video forward or backward');
					vimeoGAJS.getIFrameEventMarkerData(iframeId).videoSeeking = true; // Avoid subsequent seek trackings
				}
				break;

			case 'play':
				if (!vimeoGAJS.getIFrameEventMarkerData(iframeId).videoPlayed) {
					vimeoGAJS.sendEvent(iframeEl, 'Started video');
					vimeoGAJS.getIFrameEventMarkerData(iframeId).videoPlayed = true; // Avoid subsequent play trackings
				} else if (!vimeoGAJS.getIFrameEventMarkerData(iframeId).videoResumed && vimeoGAJS.getIFrameEventMarkerData(iframeId).videoPaused) {
					vimeoGAJS.sendEvent(iframeEl, 'Resumed video');
					vimeoGAJS.getIFrameEventMarkerData(iframeId).videoResumed = true; // Avoid subsequent resume trackings
				}
				break;

			case 'pause':
				vimeoGAJS.onPause(iframeEl);
				break;

			case 'finish':
				if (!vimeoGAJS.getIFrameEventMarkerData(iframeId).videoCompleted) {
					vimeoGAJS.sendEvent(iframeEl, 'Completed video');
					vimeoGAJS.getIFrameEventMarkerData(iframeId).videoCompleted = true; // Avoid subsequent finish trackings
				}
				break;
		}
	},

	getLabel: function(iframeEl) {
		var iframeSrc = iframeEl.attr('src').split('?')[0];
		var label = iframeSrc;
		if (iframeEl.data('title')) {
			label += ' (' + iframeEl.data('title') + ')';
		} else if (iframeEl.attr('title')) {
			label += ' (' + iframeEl.attr('title') + ')';
		}
		return label;
	},

	// Helper function for sending a message to the player
	post: function(action, value, iframe) {
		var data = {
			method: action
		};

		if (value) {
			data.value = value;
		}

		// Source URL
		var iframeSrc = $(iframe).attr('src').split('?')[0];

		if (iframeSrc.startsWith('//')) {
			// postMessage throws the following if URL starts with '//'
			// 	Uncaught DOMException: Failed to execute 'postMessage' on 'Window': Invalid target origin '//player.vimeo.com/video/301095880' in a call to 'postMessage'.
			iframeSrc = 'https:' + iframeSrc;
		}

		iframe.contentWindow.postMessage(JSON.stringify(data), iframeSrc);
	},

	isVimeoIFrame: function(iframe) {
		return iframe.src.indexOf("//player.vimeo.com") !== -1;
	},

	onReady: function(iframe) {
		// $('iframe').each(function(index, iframe) {
			if (vimeoGAJS.isVimeoIFrame(iframe)) {
				vimeoGAJS.post('addEventListener', 'play', iframe);
				vimeoGAJS.post('addEventListener', 'seek', iframe);
				vimeoGAJS.post('addEventListener', 'pause', iframe);
				vimeoGAJS.post('addEventListener', 'finish', iframe);
				vimeoGAJS.post('addEventListener', 'playProgress', iframe);
			}
		// })
	},

	onPause: function(iframeEl) {
		var iframeId = iframeEl.attr('id');
		if (vimeoGAJS.getIFrameEventMarkerData(iframeId).timePercentComplete < 99 && !vimeoGAJS.getIFrameEventMarkerData(iframeId).videoPaused) {
			vimeoGAJS.sendEvent(iframeEl, 'Paused video');
			vimeoGAJS.getIFrameEventMarkerData(iframeId).videoPaused = true; // Avoid subsequent pause trackings
		}
	},

	// Tracking video progress
	onPlayProgress: function(data, iframeEl) {
		var progress;
		var iframeId = iframeEl.attr('id');

		var markerData = vimeoGAJS.getIFrameEventMarkerData(iframeId);
		var percent = markerData.timePercentComplete = Math.round((data.percent) * 100); // Round to a whole number
		
		if (percent > 24 && !markerData.progress25) {
			progress = 'Played video: 25%';
			markerData.progress25 = true;
		}

		if (percent > 49 && !markerData.progress50) {
			progress = 'Played video: 50%';
			markerData.progress50 = true;
		}

		if (percent > 74 && !markerData.progress75) {
			progress = 'Played video: 75%';
			markerData.progress75 = true;
		}

		if (progress) {
			vimeoGAJS.sendEvent(iframeEl, progress);
		}
	},

	// Send event to Classic Analytics, Universal Analytics or Google Tag Manager
	sendEvent: function(iframeEl, action) {
		var label = vimeoGAJS.getLabel(iframeEl);
		analytics.trackEvent('Vimeo', action, label, undefined, false);
	}
};
module.exports = vimeoGAJS;